// advisor.service.js
import axios from 'axios';
import { authHeader } from '../helpers';

const axiosInstance = axios.create({
  baseURL: '' // keep if you rely on relative URLs
});

// 🔥 GLOBAL RESPONSE HANDLER
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error?.response?.status;

    if (status === 401) {
      localStorage.removeItem('user');

      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }

      // ✅ STOP propagation completely
      return new Promise(() => {});
    }

    return Promise.reject(error);
  }
);

export const advisorService = {
  getCodes
};

async function getCodes() {
  const requestOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    withCredentials: true
  };

  const response = await axiosInstance.post('/api/dataview/my-codes', {}, requestOptions);

  return response.data;
}
